export function Speedometer(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99995 12C6.99995 12.8284 6.32837 13.5 5.49995 13.5C4.67152 13.5 3.99995 12.8284 3.99995 12C3.99995 11.1716 4.67152 10.5 5.49995 10.5C6.32837 10.5 6.99995 11.1716 6.99995 12Z"
          fill="currentColor"
        />
        <path
          d="M18.4999 13.5C19.3284 13.5 19.9999 12.8284 19.9999 12C19.9999 11.1716 19.3284 10.5 18.4999 10.5C17.6715 10.5 16.9999 11.1716 16.9999 12C16.9999 12.8284 17.6715 13.5 18.4999 13.5Z"
          fill="currentColor"
        />
        <path
          d="M17.4669 8.26805L13.2803 13.292C12.6346 14.0669 11.4829 14.1716 10.708 13.5258C10.6656 13.4905 10.6248 13.4532 10.5857 13.4142C9.87247 12.7009 9.87247 11.5445 10.5857 10.8312C10.6248 10.7922 10.6656 10.755 10.708 10.7196L15.7319 6.53302C16.2214 6.12512 16.9411 6.15777 17.3916 6.6083C17.8422 7.05884 17.8748 7.77858 17.4669 8.26805Z"
          fill="currentColor"
        />
        <path
          d="M7.49995 18C8.32837 18 8.99995 17.3284 8.99995 16.5C8.99995 15.6716 8.32837 15 7.49995 15C6.67152 15 5.99995 15.6716 5.99995 16.5C5.99995 17.3284 6.67152 18 7.49995 18Z"
          fill="currentColor"
        />
        <path
          d="M8.99995 7.49999C8.99995 8.32842 8.32837 8.99999 7.49995 8.99999C6.67152 8.99999 5.99995 8.32842 5.99995 7.49999C5.99995 6.67157 6.67152 5.99999 7.49995 5.99999C8.32837 5.99999 8.99995 6.67157 8.99995 7.49999Z"
          fill="currentColor"
        />
        <path
          d="M16.4999 18C17.3284 18 17.9999 17.3284 17.9999 16.5C17.9999 15.6716 17.3284 15 16.4999 15C15.6715 15 14.9999 15.6716 14.9999 16.5C14.9999 17.3284 15.6715 18 16.4999 18Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.354492 12C0.354492 5.56839 5.56834 0.354538 11.9999 0.354538C18.4316 0.354538 23.6454 5.56839 23.6454 12C23.6454 18.4316 18.4316 23.6454 11.9999 23.6454C5.56834 23.6454 0.354492 18.4316 0.354492 12ZM21.3545 12C21.3545 6.83362 17.1663 2.64545 11.9999 2.64545C6.83357 2.64545 2.6454 6.83362 2.6454 12C2.6454 17.1664 6.83357 21.3545 11.9999 21.3545C17.1663 21.3545 21.3545 17.1664 21.3545 12Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
